import axios from 'axios';
import { config } from '../config';


// const api_server = 'https://opvc.inclass.vc/api';
const api_server = config.domainUrl
function post(name, path, { body }) {

    let token = localStorage.getItem('token')
    // console.log("tokkkk", token)
    let sub = localStorage.getItem('sub')

    let url = api_server + '/' + name + path;
    // console.log(url);
    // console.log("body in post method==========>", body)

    let headers

    if (sub == null || sub == undefined || token == null || token == undefined) {
        headers = {
            'Content-Type': 'application/json',
        }
    } else {
        headers = {
            'Content-Type': 'application/json',
            authorization: token,
            sub: sub
        }
    }
    if (body) {
        if (body.sub && body.sub !== '') {
            headers['sub'] = body.sub
        }
    }
    // console.log("headers in post method ", headers)
    return new Promise(function (resolve, reject) {
        axios.post(url, body, { headers })
            .then(res => {
                resolve(res.data)
            }).catch(err => {
                console.log("errorinaxos", err)
                reject(err);
            })
    })

}

function get(name, path) {
    return new Promise(function (resolve, reject) {
        // let url;
        let token = localStorage.getItem('token')
        let sub = localStorage.getItem('sub')
        let url = api_server + '/' + name + path;
        let headers

        if (sub == null || sub == undefined || token == null || token == undefined || token === "undefined") {
            headers = {
                'Content-Type': 'application/json',
            }
        } else {
            // console.log("this is printed")
            headers = {
                'Content-Type': 'application/json',
                authorization: token,
                sub: sub
            }
        }

        // if(sub === undefined || sub === null && token === undefined || token === null){
        //     headers = {
        //         'Content-Type': 'application/json',
        //     }
        // }else if (sub !== undefined || sub !== null && token === undefined && token === null){
        //     headers = {
        //         'Content-Type': 'application/json',
        //          sub: sub
        //     }
        // }else if (sub === undefined || sub == null && token !== undefined){
        //     headers = {
        //         'Content-Type': 'application/json',
        //         authorization: token,
        //     }
        // }else{
        //     headers = {
        //         'Content-Type': 'application/json',
        //         authorization: token,
        //         sub: sub
        //     }

        // }
        // const headers = {
        //     'Content-Type': 'application/json',
        //     authorization: token,
        //     sub: sub
        // }

        // console.log("url=====", url);
        // console.group("headers in get api", headers)

        axios.get(url, { headers })
            .then(res => {
                // console.log("res === ", res);
                resolve(res.data)
            }).catch(err => {
                console.log("errorinaxos", err)
                reject(err);
            })
    })
}

function put(name, path, { body }) {
    // let url;

    let token = localStorage.getItem('token')
    let sub = localStorage.getItem('sub')

    let headers

    if (sub == null || sub == undefined || token == null || token == undefined) {
        headers = {
            'Content-Type': 'application/json',
        }
    } else {
        headers = {
            'Content-Type': 'application/json',
            authorization: token,
            sub: sub
        }
    }


    // const headers = {
    //     'Content-Type': 'application/json',
    //     authorization: localStorage.getItem('token'),
    //     sub: localStorage.getItem('sub')
    // }

    let url = api_server + '/' + name + path;

    // console.log("url=====", url);

    return new Promise(function (resolve, reject) {

        axios.put(url, body, { headers })
            .then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err);
            })
    })
}

function del(name, path, payload = undefined) {


    let token = localStorage.getItem('token')
    // console.log("tokkkk", token)
    let sub = localStorage.getItem('sub')

    let headers

    if (sub == null || sub == undefined || token == null || token == undefined) {
        headers = {
            'Content-Type': 'application/json',
        }
    } else {
        headers = {
            'Content-Type': 'application/json',
            authorization: token,
            sub: sub
        }
    }

    // const headers = {
    //     'Content-Type': 'application/json',
    //     authorization: localStorage.getItem('token'),
    //     sub: localStorage.getItem('sub')
    // }
    let url = api_server + '/' + name + path;

    const options = {
        method: 'DELETE',
        headers: headers,
        url: url
    };
    if (payload && payload.body && payload.body !== null) {
        options['data'] = JSON.stringify(payload.body)
    }

    return new Promise(function (resolve, reject) {
        axios(options)
            .then(res => {
                resolve(res)
            }).catch(err => {
                reject(err);
            })
    })
}
function callApi(path, method, body) {
    let url;
    axios.post(url).then(res => {

    })

}

function upload(name, path, body) {

    let url = api_server + '/' + name + path;
    // console.log(url);


    let token = localStorage.getItem('token')
    // console.log("tokkkk", token)
    let sub = localStorage.getItem('sub')



    let headers

    if (sub == null || sub == undefined || token == null || token == undefined) {
        headers = {
            'Content-Type': 'application/json',
        }
    } else {
        headers = {
            'Content-Type': 'application/json',
            authorization: token,
            sub: sub
        }
    }


    // const headers = {
    //     'Content-Type': 'multipart/form-data',
    //     authorization: localStorage.getItem('token'),
    //     sub: localStorage.getItem('sub')
    // }
    // console.log("MCu headers==============>", headers);
    return new Promise(function (resolve, reject) {
        axios({
            method: 'post',
            url: url,
            data: body,
            headers: headers
        }).then((res) => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        })
    });
}



export const OffLineAPI = {
    post,
    get,
    put,
    del,
    upload
}